export function uuid() {
  return crypto.randomUUID().toLowerCase()
}
